// Initials + a stable colour for a sender, for the small avatar the /V2
// message list shows beside each name. The same name always gets the same
// colour, so a regular correspondent is recognisable at a glance. Cached:
// the list renders hundreds of rows and re-renders on every poll.

// Hues chosen to sit with the Pinpoint indigo/orange rather than fight it.
const HUES = [230, 258, 205, 172, 145, 28, 340, 12];
const cache = new Map();

function initialsOf(name) {
  let text = String(name || '').replace(/<[^>]*>/g, ' ').trim();   // "Name <addr>" → "Name"
  if (!/\s/.test(text) && text.includes('@')) text = text.split('@')[0];  // bare address → local part
  const words = text
    .replace(/["'()[\]]/g, ' ')
    .split(/[\s@._-]+/)
    .filter(w => /[A-Za-z0-9]/.test(w));
  if (!words.length) return '?';
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : '';
  return (first + last).toUpperCase();
}

export function senderAvatar(name) {
  const key = String(name || '');
  let hit = cache.get(key);
  if (hit) return hit;
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) | 0;
  const hue = HUES[Math.abs(h) % HUES.length];
  hit = {
    initials: initialsOf(key),
    style: { background: `hsl(${hue} 60% 92%)`, color: `hsl(${hue} 45% 30%)` },
  };
  if (cache.size > 2000) cache.clear();
  cache.set(key, hit);
  return hit;
}
